import React, { useMemo } from "react";
import Chessboard from "./Chessboard";
import { useBoardState } from "../../hooks/board_state";
import "./InfiniteChessTV.scss";

const InfiniteChessTV: React.FC = () => {
  const {
    pieces,
    players,
    pawnDirections,
    turn,
    turnSecondsRemaining,
    turnLengthSeconds,
    isConnected,
    isLoading,
    getPlayerColor,
  } = useBoardState({ spectator: true });

  const boardPlayers = useMemo(
    () =>
      players.map((player) => {
        const playerPieces = pieces.filter(
          (piece) => piece.player_id === player.id
        );
        const king = playerPieces.find((piece) => piece.type === "king");
        const spawnPosition = king?.position ??
          playerPieces[0]?.position ?? { row: 0, col: 0 };

        return {
          id: player.id,
          spawnPosition,
        };
      }),
    [players, pieces]
  );

  const focusPlayerId =
    turn?.player_id ?? players.find((player) => player.is_turn)?.id ?? players[0]?.id ?? "";

  const activeTurnPlayer = players.find((player) => player.id === focusPlayerId);

  if (isLoading && pieces.length === 0) {
    return <div className="infinite-chess-tv__loading">Connecting...</div>;
  }

  return (
    <div className="infinite-chess-tv">
      <div className="infinite-chess-tv__hud">
        <h1>Infinite Chess</h1>
        <div className="infinite-chess-tv__status">
          {!isConnected && <span className="infinite-chess-tv__offline">Reconnecting</span>}
          {activeTurnPlayer && turn && (
            <span className="infinite-chess-tv__turn">
              {activeTurnPlayer.display_name || activeTurnPlayer.id}
              {" · "}
              {turnSecondsRemaining.toFixed(1)}s
            </span>
          )}
          {players.length > 0 && (
            <span className="infinite-chess-tv__players">
              {players.length} player{players.length === 1 ? "" : "s"}
            </span>
          )}
        </div>
      </div>

      <div className="infinite-chess-tv__board">
        <Chessboard
          darkSquareColor="#695695"
          pieces={pieces}
          players={boardPlayers}
          pawnDirections={pawnDirections}
          getPlayerColor={getPlayerColor}
          activePlayerId={focusPlayerId}
          isMyTurn={false}
          turnSecondsRemaining={turnSecondsRemaining}
          turnLengthSeconds={turnLengthSeconds}
          selectedBankPiece={null}
          onSelect={async () => ({ success: false })}
          onMove={async () => ({ success: false })}
          onDrop={async () => ({ success: false })}
        />
      </div>
    </div>
  );
};

export default InfiniteChessTV;
